import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './page/login/login.component';
import { AdminComponent } from './theme/layout/admin/admin.component';
import { AuthComponent } from './theme/layout/auth/auth.component';
import { LoggedInGuard } from './page/security/loggedin.quard';
import { HomeGestaoComponent } from './page/home-gestao/home-gestao.component';
import { HomeOperadoraComponent } from './page/home-operadora/home-operadora.component';
import { HomeComponent } from './page/home/home.component';
import { HomeEmpresaComponent } from './pages/Empresa/home-empresa/home-empresa.component';
import { CadastroAdvogadoComponent } from './pages/Empresa/cadastro-advogado/cadastro-advogado.component';
import { CadastroClienteComponent } from './pages/Empresa/cadastro-cliente/cadastro-cliente.component';
import { CadastroTradutorComponent } from './pages/Empresa/cadastro-tradutor/cadastro-tradutor.component';
import { CadastroPesquisadorComponent } from './pages/Empresa/cadastro-pesquisador/cadastro-pesquisador.component';
import { ChatComponent } from './pages/Empresa/chat/chat.component';
import { LandpageComponent } from './pages/site/landpage/landpage.component';
import { ColetaTradutorComponent } from './pages/site/coleta-tradutor/coleta-tradutor.component';
import { ColetaPesquisadorComponent } from './pages/site/coleta-pesquisador/coleta-pesquisador.component';
import { ColetaAdvogadoComponent } from './pages/site/coleta-advogado/coleta-advogado.component';
import { ColetaClienteComponent } from './pages/site/coleta-cliente/coleta-cliente.component';



const routes: Routes = [
  {
    path: '',
    component: AdminComponent,
    children: [
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full'
      },
      {
        path: 'sample-page',
        loadChildren: () => import('./demo/pages/sample-page/sample-page.module').then(module => module.SamplePageModule)
      }
      , { path: 'home', component: HomeComponent, canLoad: [LoggedInGuard], canActivate: [LoggedInGuard] }
      ,{ path: 'home-gestao', component: HomeGestaoComponent, canLoad: [LoggedInGuard], canActivate: [LoggedInGuard] }
      , { path: 'home-operadora', component: HomeOperadoraComponent, canLoad: [LoggedInGuard], canActivate: [LoggedInGuard] }
      , { path: 'home-empresa', component: HomeEmpresaComponent, canLoad: [LoggedInGuard], canActivate: [LoggedInGuard] }
      , { path: 'cadastro-advogado', component: CadastroAdvogadoComponent, canLoad: [LoggedInGuard], canActivate: [LoggedInGuard] }
      , { path: 'cadastro-cliente', component: CadastroClienteComponent, canLoad: [LoggedInGuard], canActivate: [LoggedInGuard] }
      , { path: 'cadastro-tradutor', component: CadastroTradutorComponent, canLoad: [LoggedInGuard], canActivate: [LoggedInGuard] }
      , { path: 'cadastro-pesquisador', component: CadastroPesquisadorComponent, canLoad: [LoggedInGuard], canActivate: [LoggedInGuard] }
      , { path: 'chat', component: ChatComponent, canLoad: [LoggedInGuard], canActivate: [LoggedInGuard] }]
  }
  ,
  {
    path: '',
    component: AuthComponent,
    children: [
      { path: 'site', component: LandpageComponent },
      { path: 'login', component: LoginComponent },
      { path: 'tradutor', component: ColetaTradutorComponent },
      { path: 'pesquisador', component: ColetaPesquisadorComponent },
      { path: 'advogado', component: ColetaAdvogadoComponent },
      { path: 'cliente', component: ColetaClienteComponent },
     
      //{ path: 'cadastro-usuario', component: CadastroUsuarioComponent } ,

      //{ path: 'completar-cadastro-externo/:idEncrypted', component: CompletarCadastroComponent }
    ]
  }/*,
  {
    path: '',
    component: AuthComponent,
    children: []
  }*/
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
